<i18n>
{
  "en": {
      "subscription_confirmed": "Subscription confirmed.",
      "waiting_payment_completed": "In order to activate your license, PayPal will need to process your first payment, and that usually takes at least 2 minutes. Please come back and check your license in a few minutes.",
      "if_license_not_appear": "If your license is not activated after 10-15 minutes, it usually means the payment did not process successfully. Due to the privacy protection policy of PayPal, we will not know the reason payment failed. You may need to contact PayPal for further information. Or, you can try to subscribe by credit card. Thank you for your understanding.",
      "confirm_readed": "Please confirm you have read the above content"
  },
  "zhHant": {
      "subscription_confirmed": "訂閱已確認",
      "waiting_payment_completed": "使用PayPal訂閱在第一次付款時需等待PayPal系統啟用，通常約至少兩分鐘才會完成付款動作，因此不會立刻出現您購買的授權，請稍待一下下後再回來XRobotmon查看。",
      "if_license_not_appear": "請注意，若您的授權在一段時間後仍未出現，這通常意味著付款並沒有成功。然而因來自PayPal的個人訊息保護政策，我們並無法取得付款失敗的原因，您可能要直接聯繫PayPal以獲取您個人PayPal帳戶的進一步訊息。或是您可以嘗試改用信用卡的方式訂閱，感謝您的理解。",
      "confirm_readed": "請確認已閱讀上述內容"
  },
  "ja": {
      "subscription_confirmed": "ご契約が完了しました",
      "waiting_payment_completed": "ライセンスの有効化には、PayPalでの初回のお支払い処理が完了する必要があります（通常2分以上かかります）。しばらくしてから、Xロボットモンのウェブページでライセンスをご確認ください。この度はお申し込みいただき、誠にありがとうございます！",
      "if_license_not_appear": "10〜15分経ってもライセンスが有効化されない場合は、お支払いが正常に完了しなかった可能性があります。PayPalの個人情報保護の方針により、当社ではお支払いに失敗した理由を確認できません。お手数ですが、詳細はPayPalへお問い合わせください。なお、クレジットカードでのお申し込みもご利用いただけます。ご理解のほど、よろしくお願いいたします。",
      "confirm_readed": "上記の内容をご確認のうえ、チェックを入れてください"
  },
  "ko": {
      "subscription_confirmed": "구독이 확인되었습니다",
      "waiting_payment_completed": "PayPal 구독은 처음 결제할 때 PayPal 시스템이 켜지기를 기다립니다. 보통 최소 2분이 지나야 결제 동작이 끝나기 때문에 구매할 수 있는 인증서가 나타나지 않습니다. 잠시 후에 다시 XRobotmon으로 돌아와 보십시오.",
      "if_license_not_appear": "만약 당신의 라이선스가 일정 시간 후에도 나타나지 않는다면,이것은 일반적으로 지불이 성공하지 않았다는 것을 의미합니다.하지만 PayPal로부터의 개인 정보 보호 정책 때문에 결제 실패의 원인을 찾을 수 없습니다. PayPal 계정에 대한 추가 정보를 얻기 위해서 PayPal에 직접 연락하셔야 할 수도 있습니다.혹은 신용카드로 구독해 보실 수 있습니다. 이해해 주셔서 감사합니다.",
      "confirm_readed": "위 내용을 읽었는지 확인해주세요."
  }
}
</i18n>

<template>
  <v-container column justify-space-between bg>
    <v-layout row wrap align-center v-show="status === 'WAITING_PAYMENT_COMPLETED'">
      <v-alert value="true" type="success" outline style="width: 100%">{{ $t('subscription_confirmed') }}</v-alert>
      <div class="confirm-box-container">
        <v-checkbox v-model="isConfirmed" color="info">
        <template v-slot:label>
          <div class="confirm-box-text">
            {{ $t('waiting_payment_completed') }}
            <div class="divider"></div>
            {{ $t('if_license_not_appear') }}
          </div>
        </template>
        </v-checkbox>
      </div>
      <div class="ok-button">
        <div v-if="showWarning" class="confirm-warning">{{ $t('confirm_readed') }}</div>
        <div @click="checkIfValid">
          <v-btn color="info" :disabled="!isConfirmed" block @click="$router.push({ name: 'home' })" style="width: 100%">OK</v-btn>
        </div>
      </div>
     </v-layout>
  </v-container>
</template>

<script>
// TODO: check subscription by ID and show success if subscription activated
// return_url: "paypal?subscription_id=I-PFW8N485VA16&ba_token=BA-54756372TC142842A&token=7AS07567GB5145129"
import firebase from 'firebase/app';
import { trackAbConvert } from '@/misc/ab';

export default {
  name: 'paypal',
  components: {},
  data() {
    return {
      status: 'WAITING_PAYMENT_COMPLETED',
      isConfirmed: false,
      showWarning: false,
    };
  },
  created() {
    // PayPal's return_url — the last step of every landing-page A/B funnel.
    trackAbConvert('purchase', firebase.auth().currentUser);
  },
  watch: {
    isConfirmed() {
      this.showWarning = false;
    }
  },
  methods: {
    checkIfValid() {
      console.log()
      if (!this.isConfirmed) {
        this.showWarning = true;
      }
    }
  },
};
</script>

<style scoped>
.confirm-box-container {
  width: 100%;
  padding: 16px;
  margin: 16px;
  border: 1px solid #2196f3;
  margin: 0px;
}
.confirm-box-text {
  color: #2196f3;
  font-size: 14px;
  margin-left: 8px;
}
.divider {
  height: 1px;
  background: #2196f3;
  opacity: 0.22;
  margin: 8px 0px;
}
.confirm-warning {
  color: red;
}
.ok-button {
  width: 100%;
  padding: 8px 0px;
  text-align: center;
}
</style>
